export class ZoneImportModel {
    counter: number = 0;
    branchCode: number = 0;
    name: string = "";
    sellerDocument: string = "";
    sellerName: string | null = null;

    constructor(counter: number,
        branchCode: number,
        name: string,
        sellerDocument: string,
        sellerName: string,
    ) {
        this.counter = counter
        this.branchCode = branchCode;
        this.name = name;
        this.sellerDocument = sellerDocument;
        this.sellerName = sellerName;
    }
}